<template>
  <div>
    <div v-show="phoneNumber">
      {{ eyeFlag?allPhoneNumber:phoneNumber }}
      <span
        v-permission="permissions"
        class="eye"
        :class="eyeFlag ? 'open_eye' : 'close_eye'"
        @click="togglePhone"
      />
    </div>
    <div v-if="!phoneNumber">--</div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'UmPhoneDisplay',
  props: {
    // 手机号
    phoneNumber: {
      type: String,
      default: ''
    },
    // 接口
    listApi: {
      type: String,
      default: ''
    },
    // 权限
    permissions: {
      type: Array,
      default: () => []
    },
    // 参数
    params: {
      type: Object,
      default: () => {}
    },
    // 接口请求的方法 （get或者post）
    method: {
      type: String,
      default: 'post'
    }
  },
  data() {
    return {
      eyeFlag: false,
      allPhoneNumber: ''
    }
  },
  methods: {
    togglePhone() {
      this.eyeFlag = !this.eyeFlag
      if (this.eyeFlag && !this.allPhoneNumber) {
        // 初始值
        this.allPhoneNumber = this.phoneNumber
        const params = {
          url: this.listApi,
          method: this.method,
          baseURL: process.env.VUE_APP_BASE_URL
        }
        if (this.method === 'post') {
          params.data = this.params
        }
        if (this.method === 'get') {
          params.params = this.params
        }
        request(params).then(res => {
          if (this.method === 'post') {
            this.allPhoneNumber = res.data
          } else {
            this.allPhoneNumber = res.data.phone
          }
        }).catch(e => {
          this.$emit('error', e)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eye{
  width: 14px;
  height: 14px;
  margin-left: 5px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
.open_eye{
  width: 14px;
  height: 14px;
  background: url("@/assets/images/open_eye@2x.png") no-repeat;
  background-size: 100% 100%;
}
.close_eye{
  width: 14px;
  height: 14px;
  background: url("@/assets/images/close_eye@2x.png") no-repeat;
  background-size: 100% 100%;
}
</style>
